// import request from './request';
import {
  request
} from '../main';


/**
 * 获取验证码
 * @param {*} data 登录参数对象
 * @param {*} data.verifyType 验证类型 login/recover/register
 * @param {*} data.mobileNo   手机号
 * @param {*} data.userType   用户类型 user/main/iam
 * @returns 
 */
export function getCaptcha(data) {
  return request({
    url: 'verify/Sms/sendSms',
    method: 'post',
    data: data
  })
}

/**
 * 企业登录
 * @param {*} data 登录参数对象
 * @param {*} data.type pc
 * @param {*} data.mobileNo 手机号
 * @param {*} data.password 密码
 * @param {*} data.captcha 验证码
 * @returns 
 */
export function qiyeLoginMain(data) {
  return request({
    url: 'verify/Login/qiyeLoginMain',
    method: 'post',
    data: data
  })
}


/**
 * 获取子账号列表
 * @param {*} data 子账号列表参数对象
 * @param {*} data.page 页码
 * @param {*} data.pageSize 每页数量
 * @param {*} data.iam_static 账号状态
 * @returns {*} 
 */
export function getUserSubList(data) {
  return request({
    url: 'verify/company/getIamList',
    method: 'post',
    data: data  
  })
}
/**
 * /verify/company/createIam 创建子账号
 * @param {*} data 子账号创建参数对象
 * @param {*} data.cardid 子账号ID
 * @param {*} data.name 密码
 * @param {*} data.password 密码
 * @param {*} data.mobileNo 手机号
 * @param {*} data.email 邮箱
 * @returns {*} 
 */
export function createUserSub(data) {
  return request({
    url: 'verify/company/createIam',
    method: 'post',
    data: data
  })
}

/**
 * 更新子账号状态/updateIam
 * @param {*} data 子账号状态更新参数对象
 * @param {*} data.password 子账号密码
 * @param {*} data.email 邮箱
 * @param {*} data.mobile 联系电话
 * @param {*} data.iam_static 账号状态
 * @returns {*} 
 */
export function updateUserSubStatus(data) {
  return request({
    url: 'verify/company/updateIam',
    method: 'post',
    data: data
  })
}


/**
 * 子账号登录
 * @param {*} data 子账号登录参数对象
 * @param {*} data.companyName 主账号
 * @param {*} data.name 子账号
 * @param {*} data.password 密码
 * @param {*} data.type 登录类型 pc/iams
 * @returns {*} 
 */
export function iamLogin(data) {
  return request({
    url: 'verify/company/iamLogin',
    method: 'post',
    data: data
  })
}

/**
 * 不动产下单
 * @param {*} data 不动产下单参数对象
 * @param {*} data.goodid 商品ID  ： 1
 * @param {*} data.name 姓名
 * @param {*} data.cardid 证件号码
 * @param {*} data.file 含有CA签章的BASE64
 * @returns {*} 
 */
export function createBdcOrder(data) {
  return request({
    url: 'user/order/creatbdcorder',
    method: 'post',
    data: data
  })
}

/**
 * 缴存支付
 * @param {*} data 缴存支付参数对象
 * @param {*} data.amount 金额
 * @param {*} data.paytype 支付类型 ALIPAY/WECHAT_PAY/CORPORATE_TRANSFER
 * @returns {*} 
 */
export function payPay(data) {
  return request({
    url: 'user/recharge/pay',
    method: 'post',
    data: data
  })
}


/**
 * 支付状态查询
 * @param {*} data 支付状态查询参数对象
 * @param {*} data.orderno 支付订单ID
 */
export function rechargeStatus(data) {
  return request({
    url: 'user/recharge/status',
    method: 'post',
    data: data
  })
}


/**
 * 获取钱包信息
 * @param {*} data 获取钱包信息参数对象
 */
export function getWalletInfo(data) {
  return request({
    url: 'user/wallet/getwallet',
    method: 'post',
    data: data
  })
}



/**
 * 获取支付订单列表
 * @param {*} data 支付订单列表参数对象
 * @param {*} data.page 页码
 * @param {*} data.pageSize 每页数量
 * @param {*} data.status //"PENDING"  "SUCCESS"  "TIMEOUT"   待支付    支付成功   支付超时
 * @param {*} data.paytype ALIPAY";// 支付宝"WECHAT_PAY";// 微信支付"CORPORATE_TRANSFER"; // 对公打款
 * @returns {*} 
 */
export function getPayOrderList(data) {
  return request({
    url: 'user/recharge/getrechargeorderlist',
    method: 'post',
    data: data
  })
}

/**
 * 钱包流水
 */
export function getWalletLogList(data) {
  return request({
    url: 'user/wallet/loglist',
    method: 'post',
    data: data
  })
}

/**
 * 主账号调用订单列表(脱敏数据)
 * @param {*} data 主账号调用订单列表参数对象
 * @param {*} data.page 页码
 * @param {*} data.pageSize 每页数量
 * @param {*} data.status 订单状态 //空全部、1，查询中，2查询成功，3查询失败
 * @param {*} data.sub_id 子账号ID
 * @returns {*} 
 */
export function getJpOrderList(data) {
  return request({
    url: 'user/order/getjporderlist',
    method: 'post',
    data: data
  })
}

/**
 * 主账号的数据中心的排行榜应用
 */
export function getPhbList(data) {
  return request({
    url: 'user/order/phblist',
    method: 'post',
    data: data
  })
}

/**
 * 主账号的数据中心的核心数据
 */
export function getOverview(data) {
  return request({
    url: 'user/data/ls/getdata',
    method: 'post',
    data: data
  })
}

/**
 * 子账号业务订单数据列表
 * @param {*} data 子账号业务订单数据列表参数对象
 * @param {*} data.page 页码
 * @param {*} data.pageSize 每页数量
 * @param {*} data.name 姓名
 * @param {*} data.cardid 证件号码
 * @param {*} data.status 订单状态 //空全部、1，查询中，2查询成功，3查询失败
 * @param {*} data.state 订单状态 //0全部、1，查询中，2查询成功，3查询失败
 * @param {*} data.orderNo 订单号
 * @returns {*} 
 */
export function getIamOrderList(data) {
  return request({
    url: 'user/order/iambdclist',
    method: 'post',
    data: data
  })
}


/**
 * 下载BD文件流
 * @param {*} data 下载BD文件流参数对象
 * @param {*} data.orderNo 订单号
 * @returns {*} 
 */
export function exportBdcOrder(data) {
  return request({
    url: 'user/order/export',
    method: 'post',
    responseType: 'blob',   // 必须加！不加就是字符串，文件必损坏
    data: data
  })
}
